<template>
  <div class="live-radio">
    <div class="live-radio__flex">
      <div class="live-radio__flex__row">
        <div class="live-radio__flex__player">
          <button class="live-button"
                  :class="{ live: playingChannel1 }"
                  @click="radioPlay(1)"
          >
            <Loading v-if="loadingChannel1" />
            <PlayIcon v-else-if="!playingChannel1" />
            <StopIcon v-else />
            <span>LIVE 1</span>
            <div class="live-ping" />
            <div v-if="isLiveStreamInfoReady" class="live-button__text">
              {{ playingNowTitle1 }}
            </div>
          </button>
        </div>
        <div class="live-radio__flex__player--channel-2">
          <button class="live-button"
                  :class="{ live: playingChannel2 }"
                  @click="radioPlay(2)"
          >
            <Loading v-if="loadingChannel2" />
            <PlayIcon v-else-if="!playingChannel2" />
            <StopIcon v-else />
            <span>LIVE 2</span>
            <div class="live-ping" />
            <div v-if="isLiveStreamInfoReady" class="live-button__text">
              {{ playingNowTitle2 }}
            </div>
          </button>
        </div>
      </div>
      <div class="live-radio__flex__config">
        <button
          type="button"
          class="stream-info-toggle"
          :class="{ open: isLiveInfoOpen }"
          @click="liveStramDropdown()"
        >
          <ArrowIcon />
        </button>
        <div class="volume-button"
             @mouseenter="volumeOpen = true"
             @mouseleave="volumeOpen = false"
        >
          <button class="sound-button"
                  :class="{ muted: muted }"
                  @click="onSoundButtonClick"
          >
            <SoundIcon v-if="!muted" />
            <SoundIconMute v-else />
          </button>
          <div class="volume-slider" :class="{expanded: volumeOpen}">
            <input v-model="volume"
                   type="range"
                   min="0"
                   max="100"
                   @change="volumeChange"
            />
          </div>
        </div>
        <button v-b-toggle="mobileNavcollapseId" class="search-button">
          <SearchIcon v-if="!searchCollapseOpen" />
          <IconClose v-else /> 
        </button>
      </div>
    </div>
    <figure class="d-none">
      <audio id="liveChannel1"
             ref="liveChannel1"
             style="width:100%;"
             controls
             preload="none"
      >
        Your browser does not support the
        <code>audio</code> element.
      </audio>
    </figure>
    <figure class="d-none">
      <audio id="liveChannel2"
             ref="liveChannel2"
             style="width:100%;"
             controls
             preload="none"
      >
        Your browser does not support the
        <code>audio</code> element.
      </audio>
    </figure>
    <!-- TODO => needs to move to another component -->
    <div id="mixcloudWrapper">
      <div class="fixed-bottom-mix">
        <div
          id="mixcloudModule"
          class="d-flex flex-row align-items-center slide-in-bottom mixcloud-bg mixcloud-border justify-content-between"
        >
          <div id="mixcloudContainer" class="w-mix-cloud" />
          <div class="pl-3 pr-3 ">
            <div class="ping">
              <div class="circle" />
            </div>
          </div>
          <div
            class="headline-module-small bold pl-1 pr-1 w-100 d-none d-md-block d-lg-block d-xl-block"
          >
            <router-link class="mvmnt-link" :to="{ path: '/show/' + showRouterFetched }">
              {{ showDataFetched }}
            </router-link>
          </div>
          <div
            class="headline-module-small bold pl-2 pr-3 w-50 d-none d-md-block d-lg-block d-xl-block"
          >
            <router-link class="mvmnt-link" :to="{ path: '/podcasts/' + podcastRouterFetched }">
              {{ podcastDataFetched }}
            </router-link>
          </div>
          <div id="mixCloseButton" class="flex-shrink-1 bd-highlight">
            <button
              type="button"
              aria-label="Close"
              class="close close-mix"
              @click="destroyMixcloud()"
            >
              <IconClose />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PlayIcon from '@/components/svg/PlayIcon.vue';
import StopIcon from '@/components/svg/StopIcon.vue';
import ArrowIcon from '@/components/svg/ArrowIcon.vue';
import SearchIcon from '@/components/svg/SearchIcon.vue';
import SoundIcon from '@/components/svg/SoundIcon.vue';
import SoundIconMute from '@/components/svg/SoundIconMute.vue';
import Loading from '@/components/ui/Loading.vue';
import IconClose from '@/components/svg/IconClose.vue';
import { bus } from '../../main';
export default {
  name: 'AppLiveStream',
  components: {
    PlayIcon,
    StopIcon,
    ArrowIcon,
    SearchIcon,
    SoundIcon,
    Loading,
    IconClose,
    SoundIconMute
  },
  data() {
    return {
      mobileNavcollapseId: 'collapse-search',
      liveChannel1: null,
      liveChannel2: null,
      loadingChannel1: false,
      loadingChannel2: false,
      playingChannel1: false,
      playingChannel2: false,
      volumeOpen: false,
      showDataFetched: null,
      showRouterFetched: null,
      podcastDataFetched: null,
      podcastRouterFetched: null,
      mobileMenuOpen: false,
      muted: false,
      searchCollapseOpen: false,
      volume: 50,
      channelUrl1:
        'https://movementathens.out.airtime.pro/movementathens_a?_ga=2.221863196.549192854.1604689934-1315503358.1602963392',
      channelUrl2:
        'https://movementathens2.out.airtime.pro/movementathens2_a?_ga=2.158636346.1472607981.1624423442-919228124.1624423442'
    };
  },
  computed: {
    ...mapState({
      isLiveInfoOpen: state => state.liveStreamInfoState,
      channelOne: state => state.liveStreamInfoDataOne,
      channelTwo: state => state.liveStreamInfoDataTwo,
      isLiveStreamInfoReady(state) {
        return (
          Object.keys(state.liveStreamInfoDataOne).length != 0 &&
          Object.keys(state.liveStreamInfoDataTwo).length != 0
        );
      },
      playingNowTitle1(state) {
        if (state.liveStreamInfoDataOne.shows.current) {
          const currentName = state.liveStreamInfoDataOne.shows.current.name;
          const nextName = state.liveStreamInfoDataOne.shows.next[0].name;
          const playingNowName = currentName.includes('Movement Ident') ? nextName : currentName;
          return this.removeWeirdCharacters(playingNowName);
        } else {
          return 'Movement Radio #1';
        }
      },
      playingNowTitle2(state) {
        if (state.liveStreamInfoDataTwo.shows.current) {
          const currentName = state.liveStreamInfoDataTwo.shows.current.name;
          const nextName = state.liveStreamInfoDataTwo.shows.next[0].name;
          const playingNowName = currentName.includes('Movement Ident') ? nextName : currentName;
          return this.removeWeirdCharacters(playingNowName);
        } else {
          return 'Movement Radio #2';
        }
      }
    })
  },
  created() {
    // TODO => refactor in vuex store
    bus.$on('radio-status', data => {
      this.stopAllStreamPlayers();
    });
    bus.$on('destroy-mixcloud', data => {
      this.test = data;
      this.destroyMixcloud();
    });
    bus.$on('send-data-show', data => {
      this.showDataFetched = data;
      //console.log(this.showDataFetched);
    });
    bus.$on('send-show-route', data => {
      this.showRouterFetched = data;
      //console.log(this.showRouterFetched);
    });
    bus.$on('send-podcast-data', data => {
      this.podcastDataFetched = data;
      //console.log(data);
    });
    bus.$on('send-podcast-route', data => {
      this.podcastRouterFetched = data;
      //console.log(data);
    });
  },

  mounted() {
    this.liveChannel1 = this.$refs.liveChannel1;
    this.liveChannel2 = this.$refs.liveChannel2;
    this.getPlayingNow();
    this.getPlayingNow2();
    this.listenMobileMenuCollapse();
    // every one hour
    setInterval(() => {
      this.getPlayingNow();
      this.getPlayingNow2();
    }, 60000);
  },

  methods: {
    onSoundButtonClick() {
      this.muted = !this.muted;
      this.liveChannel1.muted = this.muted;
      this.liveChannel2.muted = this.muted;
    },
    stopAllStreamPlayers() {
      this.liveChannel1.load();
      this.liveChannel1.removeAttribute('src');
      this.liveChannel2.load();
      this.liveChannel2.removeAttribute('src');
    },
    listenMobileMenuCollapse() {
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        if (collapseId == 'collapse-mobile') {
          this.mobileMenuOpen = isJustShown;
        } 
        if (collapseId == 'collapse-search') {
          this.searchCollapseOpen = isJustShown;
        } 
      });
    },
    liveStramDropdown() {
      // eslint-disable-next-line vue/custom-event-name-casing
      if (this.mobileMenuOpen) this.$root.$emit('bv::toggle::collapse', 'collapse-mobile');
      // eslint-disable-next-line vue/custom-event-name-casing
      if (this.searchCollapseOpen) this.$root.$emit('bv::toggle::collapse', 'collapse-search');
      let isLiveStreamInfoOpen = this.isLiveInfoOpen;
      isLiveStreamInfoOpen = !isLiveStreamInfoOpen;
      this.$store.commit('setLiveStreamInfoState', isLiveStreamInfoOpen);
    },
    removeWeirdCharacters(value) {
      if (value.includes('&#039;')) {
        value = value.replace(/&#039;/g, "'");
      }
      if (value.includes('&amp;')) {
        value = value.replace(/&amp;/g, '&');
      }
      return value;
    },

    getPlayingNow() {
      this.$store.dispatch('setLiveStreamInfoDataOne');
    },
    getPlayingNow2() {
      this.$store.dispatch('setLiveStreamInfoDataTwo');
    },

    // play audio stream
    async playVideo(channel) {
      try {
        await channel.play();
      } catch (err) {}
    },

    // handle play/destroy audio
    radioPlay(liveChannel) {
      const live = liveChannel === 1 ? this.liveChannel1 : this.liveChannel2;
      const live2 = liveChannel === 2 ? this.liveChannel1 : this.liveChannel2;
      const liveUrl = liveChannel === 1 ? this.channelUrl1 : this.channelUrl2;
      if (live.paused) {
        live.setAttribute('src', liveUrl);
        this.playVideo(live);
        live.onwaiting = () => {
          if (liveChannel === 1) {
            this.loadingChannel1 = true;
            this.loadingChannel2 = false;
          } else {
            this.loadingChannel2 = true;
            this.loadingChannel1 = false;
          }
        };
        live.onplaying = () => {
          bus.$emit('radio-on', true);
          this.loadingChannel1 = false;
          this.loadingChannel2 = false;
          live2.load();
          live2.removeAttribute('src');
          if (liveChannel === 1) {
            this.destroyMixcloud();
            this.playingChannel1 = true;
            this.playingChannel2 = false;
          } else {
            this.destroyMixcloud();
            this.playingChannel2 = true;
            this.playingChannel1 = false;
          }
        };
        live.onemptied = () => {
          if (liveChannel === 1) {
            this.playingChannel1 = false;
          } else {
            this.playingChannel2 = false;
          }
        };
        live.onstalled = () => {
          console.log('no internet');
        };
      } else {
        live.load();
        live.removeAttribute('src');
      }
    },

    volumeChange() {
      const volume = this.volume * 0.01;
      this.liveChannel1.volume = volume;
      this.liveChannel2.volume = volume;
    },

    // TODO => refactor this logic
    destroyMixcloud() {
      var mixcloudRoot = document.getElementById('mixcloudWrapper');
      const mixcloudModule = document.getElementById('mixcloudModule');
      mixcloudModule.classList.remove('slide-in-bottom');
      mixcloudModule.classList.add('slide-out-bottom');
      var mixcloudParent = document.getElementById('mixcloudContainer');
      setTimeout(() => {
        while (mixcloudParent.firstChild) {
          mixcloudParent.removeChild(mixcloudParent.firstChild);
        }
        mixcloudModule.classList.remove('slide-out-bottom');
        mixcloudRoot.style.display = 'none';
        //send data bus to showItem component
        this.sendCurrentIdNull();
      }, 500);
    },

    // TODO => refactor in vuex store
    sendCurrentIdNull() {
      bus.$emit('current-id', null);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_live-radio.scss';
//TODO move css to mixcloud component
.fixed-bottom-mix {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
.logo--bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: black;
  height: 30px;
  z-index: 1040;
}
.logo--bottom a {
  padding: 0 20px 0 20px;
}
.logo--bottom a img {
  width: 100px;
}
.text-red {
  color: red;
}
.radio--container > div:first-child {
  border-right: none;
  border-bottom: 1px solid white;
}
.radio-index {
  font-size: 18px;
  height: 25px;
}
.logo-stegi {
  transition: all 0.5s ease;
}
.logo-stegi:hover {
  opacity: 0.8;
  cursor: pointer;
}
.on-air {
  font-size: 12px;
  width: 45px;
  flex-shrink: 0;
}
.marquee-text {
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  margin: 0 8px 0 0;
  text-align: left;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -moz-box-orient: vertical;
  -webkit-box-orient: vertical;
}
@media (min-width: 1200px) {
  .on-air {
    width: auto;
  }
  .radio--container > div:first-child {
    border-right: 1px solid white;
    border-bottom: none;
  }
  .player-1:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  .player-1.radioOn:hover {
    opacity: 1;
    cursor: pointer;
    background-color: var(--artist-module-color);
    color: white;
  }
}
@media (max-width: 991px) {
  .fixed-bottom-mix {
    bottom: 0;
  }
  .logo--bottom {
    display: block;
  }

  .player-1:active {
    background: transparent !important;
  }

  @keyframes marquee {
    0% {
      opacity: 0;
      margin-left: 100%;
      transform: translateX(0%);
    }
    25% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      margin-left: 0;
      transform: translateX(-100%);
    }
  }
  .marquee-text {
    animation: marquee 15s linear infinite;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    /* display: -webkit-box; */
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
  }

  .marquee-container {
    overflow: hidden;
    position: relative;
  }
}

div#mixcloudModule {
  width: 100%;
  height: 60px;
}

#mixcloudContainer {
  height: 60px;
}
.w-mix-cloud {
  width: 100%;
  max-width: 560px;
}
#mixcloudWrapper {
  display: none;
}
#mixcloudContainer > iframe {
  border: none !important;
  height: 60px;
}
#mixCloseButton {
  background: #fcfcfc;
  width: 100%;
  max-width: 60px;
  align-self: center;
  text-align: center;
  border-left: 1px solid #d7d7d7;
  height: 100%;
}
button.close {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.circle {
  background: var(--warp-purple);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 0;

  display: block;
}
.show-data-widget {
  height: 60px;
}
.player-1 {
  font-size: 18px;
  color: black;
  line-height: 1;
  height: 50px;
  transition: all 0.5s ease;
  flex: 0 1 50%;
}
.player-1:active {
  background-color: var(--warp-purple);
}

.radioOn {
  background-color: whitesmoke;
  color: black;
}
.radioOff {
  background-color: var(--radio-on);
  color: white;
}
.live-now-btn > i:hover {
  color: white;
}
</style>
